export { default as BlogPostPlaceholder } from './blog-post'
export { default as ProductsSimplePlaceholder } from './products-simple'
export { default as ProductFeaturedPlaceholder } from './product-featured'
export { default as ProductsListPlaceholder } from './products-list'
export { default as ProductsPlaceholder } from './products'
export { default as ProductsCategoriesPlaceholder } from './product-categories'
export { default as ProductsCarouselPlaceholder } from './product-carousel'
export { default as ProductsDealsCarouselPlaceholder } from './products-deals-carousel.js'
export { default as AuthorsPlaceholder } from './authors'
export { default as DealProduct } from './deal-product'
export { default as SingleproductCarouselPlaceholder } from './single-product-carousel'